import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';

export const dividerStyles = css`
  /* Block: divider */
  .divider {
    width: 100%;
    height: 1px;
    background-color: ${colors.gray.shade2};
    border: none;
    display: block;
  }

  /* Modifiers */
  .divider--thick {
    height: 2px;
    background-color: ${colors.gray.shade5};
  }

  .divider--thin {
    height: 0.5px;
    background-color: ${colors.gray.shade1};
  }

  .divider--dashed {
    height: 0;
    border-top: 1px dashed ${colors.gray.shade2};
    background-color: transparent;
  }

  .divider--dotted {
    height: 0;
    border-top: 1px dotted ${colors.gray.shade2};
    background-color: transparent;
  }
`;
